import * as yup from 'yup';
import { List } from '@web/molecules';
import { nullableImageFromCMSSchema } from '../schemas';

export const component = List;

export const schema = yup
  .object({
    heading: yup.string(),
    icon: yup
      .mixed()
      .oneOf(['bullet', 'checkmark', 'checkmarkSimple', 'checkmarkCircle'])
      .optional(),
    items: yup.array(
      yup.object({
        heading: yup.string().nullable(),
        body: yup.string().required(),
        iconImage: nullableImageFromCMSSchema.default(undefined),
      }),
    ),
    textAlignment: yup.string(),
    typography: yup.string(),
    gap: yup.number().nullable(),
    iconColor: yup.string().nullable(),
    iconSize: yup.string().nullable(),
  })
  .transform(value => ({
    heading: value?.heading,
    icon: value?.icon === '' ? undefined : value?.icon,
    iconColor: value?.iconColor || undefined,
    iconSize: value?.iconSize ? String(value.iconSize) : undefined,
    items: value?.items,
    textAlignment: value?.textAlignment,
    typography: value?.typography,
    gap:
      value?.gap === null || value?.gap === '' || isNaN(Number(value?.gap))
        ? undefined
        : Number(value?.gap),
  }));
